


export let ON_SEARCH_SELECTED = 'search-selected';

